import React, { useCallback } from 'react'
import GridButton from '../../common/components/GridButton'
import { zoomTo } from '../../map';
import { Crosshair } from 'react-feather';

interface ZoomToButtonProps {
  geometry: __esri.Geometry | undefined;
}

const ZoomToButton: React.FC<ZoomToButtonProps> = ({ geometry }) => {
  const zoomToParcel = useCallback(() => {
    geometry && zoomTo(geometry, undefined)
  }, [geometry])

  return (
    <GridButton
      Icon={Crosshair}
      onClick={zoomToParcel}
      buttonText="Zoom To"
    />
  )
}

export default ZoomToButton